<template>
    <v-container fluid>
      <v-card>
        <v-card-title>
          Payments
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="tableData"
          :search="search"
          :sort-by.sync="sortby"
          :loading="!$store.state.have_all_payments"
          :items-per-page = "20"
        >
          <template v-slot:item.actions="{ item }">
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <!-- <v-list-item @click.stop="openStallholderDialog(item.id)">
                  <v-list-item-title>Edit Stallholder</v-list-item-title>
                </v-list-item> -->
                <v-list-item :to="`/payments/${item.id}`">
                  <v-list-item-title>View Payment Bookings</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <template v-slot:item.stall_name="{item}">
            <button text @click="$router.push('stallholders/'+item.id)">{{ item.stall_name }}</button>
          </template>
          <template v-slot:item.stallholder_type="{ item }">
            <v-tooltip bottom  v-if="item.stallholder_type">
              <template v-slot:activator="{ on }">
                <v-chip  v-on="on" :color="getStallholderColor(item.stallholder_type)" dark>{{ item.stallholder_type.charAt(0).toUpperCase() }}</v-chip>
              </template>
              <span>{{ item.stallholder_type }}</span>
            </v-tooltip>
          </template>
          <template v-slot:item.email="{ item }">
                 <v-btn text icon
            :href="`mailto:${item.email}`"
          >
            <v-icon>mdi-at</v-icon>
          </v-btn>
            {{ item.email }}
         
          </template>

          <!-- Created Date -->
          <template v-slot:item.created_date="{ item }">
            {{ formatDate(item.created_date) }}
          </template>

        </v-data-table>
      </v-card>
      
      <StallholderDialog
        :dialogVisible="isStallholderDialogVisible"
        :selectedStallholder="selectedStallholder ? selectedStallholder : false"
        @close="closeStallholderDialog"
      />

      <v-dialog
        v-model="savingDialog"
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text class="pt-5">
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
</template>



<script>

import axios from 'axios';
import { mapGetters } from 'vuex'
import StallholderDialog from '../components/StallholderDialog';
import { formatDate } from '../js/helpers'


export default {
  data() {
    return {
      search: '',
      datemenu: false,
      isStallholderDialogVisible: false,
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Reference ID', value: 'reference' },
        { text: 'Bank Transaction ID', value: 'transaction_id' },
        { text: 'Total Amount', value: 'amount' },
        { text: 'Created Date', value: 'created_date', align: 'right'},
        // { text: 'Phone', value: 'phone',  align: ' d-none' },  // ' d-none' hides the column but keeps the search ability (note: does not get hidden for mobile responsive layout)
        // { text: 'Full Name', value: 'full_name',  align: ' d-none' },
        { text: '', value: 'actions', sortable: false, align: 'right'},
      ],
      sortby: 'stall_name',
      savingDialog: false,
      selectedStallholderId: false
    }
  },
components: {
    StallholderDialog
  },
  watch: {
    //
  },
  methods: {
    openStallholderDialog (id) { 
      this.isStallholderDialogVisible = true
      this.selectedStallholderId = id;
    },
  
    closeStallholderDialog () { 
      this.isStallholderDialogVisible = false;

      // wait half a sec, before resetting data (otherwise we see the stall name cleared in the booking dialog before the dialog fully transitions)
      setTimeout(() => {
       this.selectedStallholderId = false;
      }, 500)  
    },
    formatDate(date){
      return formatDate(date);
    },
  },
  computed: {
    ...mapGetters([
      'getStallholderColor',
      'getStallholderById',
      'getCategoryById'
    ]),
    selectedStallholder() {
      return this.getStallholderById(this.selectedStallholderId)
    },
    tableData(){
        return this.$store.state.payments.map( payment => {
            // let category = this.getCategoryById(payment.category);
            // if(category)
            //   payment.payment_category = category.name;

            // payment.full_name = payment.first_name+' '+payment.last_name  

            return payment;
        });
    }
  },
  mounted(){
    console.log('mount payments')
    this.$store.dispatch('getPayments', { });
  }
}
</script>

<style>

</style>